export const FAQS = {
  NAME: 'faq',
  NAMESPACE: (name) => `faq/${name}`,
  SET_FAQ: 'SET_FAQ',
  GET_FAQ: 'GET_FAQ',
}

export const state = {
  faq: {},
}

export const mutations = {
  [FAQS.SET_FAQ](state, faq) {
    state.faq = faq
  },
}

export const getters = {
  [FAQS.GET_FAQ](state) {
    return state.faq
  },
}
